import { Action, initialState, State } from "store/store";

export const setLinks = (state: State = initialState, { data }: Action) => {
  return {
    ...state,
    links: data,
  };
};